<button nz-button nz-dropdown nzTrigger="click" [nzDropdownMenu]="menu" [(nzVisible)]="visible">
  {{ 'component.search.select_quick_message' | translate }}
  <span nz-icon nzType="down"></span>
</button>

<nz-dropdown-menu #menu="nzDropdownMenu">
  <div class="v4-layout-dropdown w-[700px]">
    <div class="v4-filter-list overflow-x-auto pb-6">
      <div class="v4-filter-item" (click)="onClickGroup(-1)">
        <div class="v4-filter v4-filter-selectable" [class.selected]="currentGroupId === -1">
          {{ 'house.all_group' | translate }}
        </div>
      </div>
      <div class="v4-filter-item" (click)="onClickGroup(group.id)" *ngFor="let group of listOfGroup">
        <div class="v4-filter v4-filter-selectable" [class.selected]="group.id === currentGroupId">
          {{ group.name }}
        </div>
      </div>
    </div>

    <div *ngIf="listOfTemplate?.length; else empty">
      <div
        class="v4-layout-list-item cursor-pointer"
        [class.selected]="tpl.select"
        (click)="onClickItem(tpl)"
        *ngFor="let tpl of listOfTemplate"
      >
        <div class="flex flex-row items-center">
          <div class="w-[100px] text-ellipsis mr-10" *ngIf="tpl.title">{{ tpl.title }}</div>
          <div class="text-ellipsis">{{ tpl.content }}</div>
        </div>
      </div>
    </div>
    <div class="flex flex-row items-center justify-between pt-[30px]">
      <a nz-button nzType="link" (click)="toTemplatePage()">
        <!-- <i nz-icon nzType="setting" nzTheme="outline"></i> -->
        {{ 'edit_rate.tpl_picker.operate.manage' | translate }}
      </a>
      <div>
        <button nz-button nzSize="large" (click)="cancel()">{{ 'word.cancel' | translate }}</button>
      </div>
      <!-- <a href="javascript:void(0);" (click)="reset()">{{ "word.reset_settings" | translate }}</a> -->
    </div>

    <ng-template #empty>
      <div class="empty">
        <img class="host-no-data-img-small" src="/assets/icon/no_data.png" />
        <p class="title">
          <!-- 暂无数据 -->
          {{ 'word.no_data' | translate }}
        </p>
      </div>
    </ng-template>
  </div>
</nz-dropdown-menu>

<v4-custom-select
  *ngIf="false"
  [placeholder]="'component.search.select_quick_message' | translate"
  [textItem]="value?.title"
  [showTextItem]="value?.title"
  [size]="size"
  [(visible)]="visible"
  size="large"
>
  <div class="v4-layout-dropdown w-[700px]">
    <div class="v4-filter-list overflow-x-auto pb-6">
      <div class="v4-filter-item" (click)="onClickGroup(-1)">
        <div class="v4-filter v4-filter-selectable" [class.selected]="currentGroupId === -1">
          {{ 'house.all_group' | translate }}
        </div>
      </div>
      <div class="v4-filter-item" (click)="onClickGroup(group.id)" *ngFor="let group of listOfGroup">
        <div class="v4-filter v4-filter-selectable" [class.selected]="group.id === currentGroupId">
          {{ group.name }}
        </div>
      </div>
    </div>

    <div *ngIf="listOfTemplate?.length; else empty">
      <div
        class="v4-layout-list-item cursor-pointer"
        [class.selected]="tpl.select"
        (click)="onClickItem(tpl)"
        *ngFor="let tpl of listOfTemplate"
      >
        <div class="flex flex-row items-center">
          <div class="w-[100px] text-ellipsis mr-10" *ngIf="tpl.title">{{ tpl.title }}</div>
          <div class="text-ellipsis">{{ tpl.content }}</div>
        </div>
      </div>
    </div>
    <div class="flex flex-row items-center justify-between pt-[30px]">
      <a nz-button nzType="link" (click)="toTemplatePage()">
        <!-- <i nz-icon nzType="setting" nzTheme="outline"></i> -->
        {{ 'edit_rate.tpl_picker.operate.manage' | translate }}
      </a>
      <div>
        <button nz-button nzSize="large" (click)="cancel()">{{ 'word.cancel' | translate }}</button>
      </div>
      <!-- <a href="javascript:void(0);" (click)="reset()">{{ "word.reset_settings" | translate }}</a> -->
    </div>

    <ng-template #empty>
      <div class="empty">
        <img class="host-no-data-img-small" src="/assets/icon/no_data.png" />
        <p class="title">
          <!-- 暂无数据 -->
          {{ 'word.no_data' | translate }}
        </p>
      </div>
    </ng-template>
  </div>
</v4-custom-select>

<div class="host-rate-tpl-picker" *ngIf="false">
  <p
    class="picker"
    nz-dropdown
    [nzDropdownMenu]="picker"
    [nzBackdrop]="false"
    [(nzVisible)]="visible"
    nzPlacement="bottomLeft"
    nzTrigger="click"
  >
    <span class="text-view">
      {{ value?.title || ('edit_rate.tpl_picker.placeholder.title' | translate) }}
    </span>
    <i nz-icon nzType="down" nzTheme="outline"></i>
  </p>

  <nz-dropdown-menu #picker="nzDropdownMenu">
    <div class="rate-tpl-picker-container">
      <div class="pc-header">
        <div class="pch-wrapper">
          <div class="group-item" [class.selected]="currentGroupId === -1" (click)="onClickGroup(-1)">
            {{ 'house.all_group' | translate }}
          </div>
          <div
            class="group-item"
            [class.selected]="group.id === currentGroupId"
            (click)="onClickGroup(group.id)"
            *ngFor="let group of listOfGroup"
          >
            {{ group.name }}
          </div>
        </div>
      </div>

      <div class="pc-body" *ngIf="listOfTemplate?.length; else empty">
        <div
          class="list-item"
          [class.selected]="tpl.select"
          (click)="onClickItem(tpl)"
          *ngFor="let tpl of listOfTemplate"
        >
          <div class="li-wrapper">
            <div class="title" *ngIf="tpl.title">{{ tpl.title }}</div>
            <div class="content">{{ tpl.content }}</div>
          </div>
        </div>
      </div>
      <div class="pc-footer">
        <a href="javascript:void(0);" (click)="toTemplatePage()">
          <i nz-icon nzType="setting" nzTheme="outline"></i>
          {{ 'edit_rate.tpl_picker.operate.manage' | translate }}
        </a>
        <div class="button-group">
          <button nz-button nzSize="small" (click)="cancel()">{{ 'word.cancel' | translate }}</button>
          <!-- <button nz-button nzSize="small" nzType="primary" (click)="confirm()">{{ "word.confirm" | translate }}</button> -->
        </div>
        <a href="javascript:void(0);" (click)="reset()">{{ 'word.reset_settings' | translate }}</a>
      </div>

      <ng-template #empty>
        <div class="empty">
          <img class="host-no-data-img-small" src="/assets/icon/no_data.png" />
          <p class="title">
            <!-- 暂无数据 -->
            {{ 'word.no_data' | translate }}
          </p>
        </div>
      </ng-template>
    </div>
  </nz-dropdown-menu>
</div>
